import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

const WHATSAPP_URL = "https://wa.me/5521974615899?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20os%20serviços%20da%20Amparo%20%26%20Aconchego.";

export default function WhatsAppButton() {
  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-whatsapp text-background rounded-full px-5 py-3 shadow-lg hover:shadow-xl transition-shadow"
      animate={{ scale: [1, 1.05, 1] }}
      transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      aria-label="Fale conosco pelo WhatsApp"
    >
      <MessageCircle className="h-5 w-5 fill-background" />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </motion.a>
  );
}
